module.exports = __webpack_public_path__ + "img/linkedin-logo.d52422fb.svg";